<template>
    <svg width="56" height="56" xmlns="http://www.w3.org/2000/svg"><path fill="#F7931A" d="M0 0h56v56H0z"/><path d="M39.936 24.704c.515-3.494-2.13-5.357-5.773-6.622l1.18-4.708-2.877-.716-1.148 4.592-2.296-.549 1.164-4.625-2.878-.715-1.181 4.725-1.83-.433v-.016l-3.976-.999-.766 3.078s2.13.5 2.096.516c1.165.3 1.365 1.065 1.332 1.664l-1.332 5.39.3.1-.316-.067-1.88 7.537c-.133.35-.5.882-1.314.665.033.05-2.08-.499-2.08-.499l-1.43 3.278 3.743.931 2.046.533-1.198 4.775 2.878.715 1.165-4.725 2.312.599-1.18 4.708 2.877.716 1.181-4.775c4.908.931 8.602.566 10.15-3.877 1.247-3.576-.067-5.623-2.646-6.987 1.88-.416 3.294-1.664 3.66-4.21h.017zm-6.572 9.217c-.882 3.577-6.904 1.63-8.85 1.164l1.58-6.338c1.946.499 8.202 1.447 7.27 5.157v.017zm.882-9.267c-.799 3.244-5.823 1.597-7.437 1.198l1.43-5.74c1.631.4 6.855 1.165 6.007 4.542z" fill="#fff"/></svg>
</template>
<script>
export default {
    props:{
        round: Boolean,
    },
    data(){
        return {

        }
    },
}
</script>
